import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AutoFirmaComponent } from './auto-firma/auto-firma';
import { BoardAdminComponent } from './board-admin/board-admin.component';
import { ClaveComponent } from './clave/clave.component';
import { ConfirmarCorreoComponent } from './confirmar-correo/confirmar-correo.component';
import { CsvViewerComponent } from './csv-viewer/csv-viewer.component';
import { FirmaClaveComponent } from './firma-clave/firma-clave.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthGuard } from './guards/auth.guard';
import { EnvironmentGuard } from './guards/environment.guard';
import { NoLoginGuard } from './guards/noLogin.guard';
import { InfoLegalComponent } from './info-legal/info-legal/info-legal.component';
import { InicioComponent } from './inicio/inicio.component';
import { LoginComponent } from './login/login.component';
import { RaizComponent } from './raiz/raiz.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { Anexo3ParticipacionConcursoComponent } from './tipo_tramites/anexo3-participacion-concurso/anexo3-participacion-concurso.component';
import { TramiteInstanciaGeneralComponent } from './tipo_tramites/tramite-instancia-general/tramite-instancia-general.component';
import { TramiteRPSVComponent } from './tipo_tramites/tramite-rpsv/tramite-rpsv.component';
import { TramiteSPVComponent } from './tipo_tramites/tramite-spv/tramite-spv.component';
import { TramiteDynamicComponent } from './tramite-dynamic/tramite-dynamic.component';

const routes: Routes = [
  {
    path: '', component: RaizComponent,
    children: [
      { path: 'inicio', component: InicioComponent },
      { path: 'login', component: LoginComponent, canActivate: [NoLoginGuard] },
      { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [NoLoginGuard] },
      { path: 'reset-password/:identificador', component: ResetPasswordComponent, canActivate: [NoLoginGuard] },
      { path: 'confirmar-correo/:identificador', component: ConfirmarCorreoComponent, canActivate: [NoLoginGuard] },
      {
        path: 'info',
        children: [
          { path: 'aviso-legal', component: InfoLegalComponent },
          { path: 'politica-privacidad', component: InfoLegalComponent },
          { path: 'proteccion-de-datos', component: InfoLegalComponent },
          { path: 'terminos-registro-general', component: InfoLegalComponent },
          { path: 'terminos-seleccion-personal', component: InfoLegalComponent },
          { path: 'terminos-registro-identificacion', component: InfoLegalComponent }
        ]
      },
      { path: 'perfil', component: BoardAdminComponent, canActivate: [AuthGuard, EnvironmentGuard], data: { allowedClients: ['emvs', 'gmu'] } },
      { path: 'RPSV/:id', component: TramiteRPSVComponent, canActivate: [AuthGuard, EnvironmentGuard], data: { allowedClients: ['emvs'] } },
      { path: 'instancia-general/:id', component: TramiteInstanciaGeneralComponent, canActivate: [AuthGuard, EnvironmentGuard], data: { allowedClients: ['emvs'] } },
      { path: 'anexo3_participacion_concurso/:id', component: Anexo3ParticipacionConcursoComponent, canActivate: [AuthGuard, EnvironmentGuard], data: { allowedClients: ['emvs'] } },
      { path: 'SPV/:id', component: TramiteSPVComponent, canActivate: [AuthGuard, EnvironmentGuard], data: { allowedClients: ['emvs'] } },
      { path: 'formulario/:id', component: TramiteDynamicComponent, canActivate: [AuthGuard, EnvironmentGuard], data: { allowedClients: ['emvs', 'gmu'] } },
      { path: 'clave/:id', component: ClaveComponent, canActivate: [EnvironmentGuard], data: { allowedClients: ['emvs', 'gmu'] } },
      { path: 'firma-clave', component: FirmaClaveComponent, canActivate: [AuthGuard, EnvironmentGuard], data: { allowedClients: ['emvs', 'gmu'] } },
      { path: 'autofirma', component: AutoFirmaComponent, data: { allowedClients: ['emvs', 'gmu'] } },
      { path: 'csv-review', component: CsvViewerComponent, canActivate: [AuthGuard], data: { allowedClients: ['emvs', 'gmu'] } },
    ]
  },
  { path: '**', redirectTo: 'inicio' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }